import React from "react";
import "../assets/css/flags.css";

class TechnicalCommittee extends React.Component {
  componentDidMount() {
    document.title =
      "ICITA 2021: Technical Committee - 15th International Conference on Information Technology and Applications (ICITA)";
  }
  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Technical committee</h1>
                  </div>
                </div>

                <div className="intro_text text-center">
                  <ul style={{ listStyleType: "circle" }} align="left">
                    <li>
                      Akay, Metin, Arizona State University, USA{" "}
                      {/* <div className="flaggg flaggg-us"></div> */}
                    </li>
                    <li>
                      Usman, Muhammad, Blekinge Institute of Technology , Sweden{" "}
                      {/* <div className="flaggg flaggg-se"></div> */}
                    </li>
                    <li>
                      Wiem, Mkaouer, Mohamed Rochester Institute of Technology,
                      New York, USA
                      {/* <div className="flaggg flaggg-us"></div> */}
                    </li>
                    <li>
                      Williams, Jason, Cardiff Metropolitan University , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Xiao, Hannan, Kings College London ,UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Adnan, Awais, Institute of Management Sciences, Pakistan{" "}
                      <div className="flaggg flaggg-pk" alt="Pakistan"></div>
                    </li>
                    <li>
                      Ahmad ,Amro Al-Said, Philadelphia University, Jordan{" "}
                      <div className="flaggg flaggg-jo" alt="Jordan"></div>
                    </li>

                    <li>
                      Ahmad, Ishtiaq, University of South , Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Ahmad, Jamil, Islamia College University Peshawar,
                      Pakistan{" "}
                      <div className="flaggg flaggg-pk" alt="Pakistan"></div>
                    </li>

                    <li>
                      Barker, Trevor, University of Hertfordshire , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Barolli, Leonard, Fukuoka Institute of Technology , Japan{" "}
                      <div className="flaggg flaggg-jp"></div>
                    </li>
                    <li>
                      Beavan, Jay, Health Education and Improvement Wales UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Bilal, Mohsin, University of Warwick , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Brassey, Jon, Oxford University , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Butcher, John, Aston University , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Chbeir, Richard, Universite de Bourgogne, France{" "}
                      <div className="flaggg flaggg-fr"></div>
                    </li>
                    <li>
                      Chen, Shaokang, The University of Queensland, Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Cheok, Adrian David, National University of Singapore{" "}
                      <div className="flaggg flaggg-sg"></div>
                    </li>
                    <li>
                      Choi, Jaeho, Chonbuk National University, Korea{" "}
                      <div className="flaggg flaggg-kr"></div>
                    </li>
                    <li>
                      Andres, Frederic, National Institute of Informatics, Japan{" "}
                      <div className="flaggg flaggg-jp"></div>
                    </li>
                    <li>
                      Araki, Kenji, Hokkaido University, Japan{" "}
                      <div className="flaggg flaggg-jp"></div>
                    </li>
                    <li>
                      Ali Khan, Arif, Nanjing University of Aeronautics and
                      Astronautics , Paksitan{" "}
                      <div className="flaggg flaggg-cn" alt="Pakistan"></div>
                    </li>
                    <li>
                      Ali Khan, Wajahat, &nbsp;University of Derby , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Ali Syed ,Toqeer, Islamic University of Medina , Saudi
                      Arabia <div className="flaggg flaggg-sa"></div>
                    </li>
                    <li>
                      Amin, Adnan, Institute of Management Sciences , Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Ammar, Adel, Prince Sultan University , Saudi Arabia{" "}
                      <div className="flaggg flaggg-sa"></div>
                    </li>

                    <li>
                      Dooley, Laurence S, Monash University, Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Durresi, Arjan, Louisiana State University, USA{" "}
                      <div className="flaggg flaggg-us"></div>
                    </li>
                    <li>
                      Fernandez, George, RMIT, Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Finley, Marion R. Jr., Asahi University, Japan{" "}
                      <div className="flaggg flaggg-jp"></div>
                    </li>
                    <li>
                      Forughian, Tooraj, BBS Access Pte Ltd, Singapore{" "}
                      <div className="flaggg flaggg-sg"></div>
                    </li>
                    <li>
                      Fu, Jiacai, Heilongjiang Institute of Science And
                      Technology , Singapore{" "}
                      <div className="flaggg flaggg-sg"></div>
                    </li>
                    <li>
                      Fujita, Satoshi, Hiroshima University, Japan{" "}
                      <div className="flaggg flaggg-jp"></div>
                    </li>
                    <li>
                      Fung, Lance, Murdoch University, Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Gandelli, Alessandro, Politecnico di Milano, Italy{" "}
                      <div className="flaggg flaggg-it"></div>
                    </li>
                    <li>
                      Gohar, Neelam, Shaheed Benazir Bhutto Women University
                      Peshawar, Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Habib, Asad,&nbsp;Kohat university of science and
                      technology, Kohat, Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Haleem, Zahid, Ghulam ishaq institute of Engineering
                      Sciences and Technology, Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Jabeen, Hajira, University of Cologne , Germany{" "}
                      <div className="flaggg flaggg-de"></div>
                    </li>
                    <li>
                      Jalil ,Zunera, Air University Islamabad , Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Jan, Zahoor, Islamia College University Peshawar, Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Khan, Ahmad, Comsats University Islamabad, Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Khan, Sifat Ullah, University of Malakand , Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Khattak, Asad,&nbsp;Zayed University , Pakistan{" "}
                      <div className="flaggg flaggg-ae"></div>
                    </li>
                    <li>
                      Khattak, Hassan&nbsp;Ali, Comsat University Islamabad,
                      Pakistan <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Luke, Karl, Cardiff University, Pakistan{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Majid&nbsp;Bhatti, Baber, University of South , Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Mehmood Minhas, Nasir, &nbsp;Blekinge Institute of
                      Technology, Sweden{" "}
                      <div className="flaggg flaggg-se"></div>
                    </li>
                    <li>
                      Mehmood, Irfan, University of Bradford , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Moreira, Fernando,&nbsp; Portucalense University, Portugal{" "}
                      <div className="flaggg flaggg-pt"></div>
                    </li>
                    <li>
                      Muhammad, Khan, Sejong University, Korea{" "}
                      <div className="flaggg flaggg-kr"></div>
                    </li>
                    <li>
                      Naseem, Rashid, Pak-Austria Fachhochschule Institute of
                      Applied Sciences and Technology , Austria{" "}
                      <div className="flaggg flaggg-at"></div>
                    </li>
                    <li>
                      Nazir, Shah, University of Swabi , Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Noor, Salma, Shaheed Benazir Bhutto Women University
                      Peshawar, Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Obeidat, Qasem, University of Bahrain , Bahrain{" "}
                      <div className="flaggg flaggg-bh"></div>
                    </li>
                    <li>
                      Panichella, Sebastiano &nbsp; Zurich University of Applied
                      Science, Switzerland{" "}
                      <div className="flaggg flaggg-ch"></div>
                    </li>
                    <li>
                      Paul, Enoiu, Eduard &nbsp;M&auml;lardalen University,
                      Sweden <div className="flaggg flaggg-se"></div>
                    </li>
                    <li>
                      Qayyum, Fawad, University of Malakand , Pakistan{" "}
                      <div className="flaggg flaggg-pk"></div>
                    </li>
                    <li>
                      Ramzan, Muhammad, Saudi Electronic University , Saudi
                      Arabia <div className="flaggg flaggg-sa"></div>
                    </li>
                    <li>
                      Rauf, Abdul, RISE-Research Institute of Sweden in
                      Vasteras, Sweden <div className="flaggg flaggg-se"></div>
                    </li>
                    <li>
                      Razzak, Imran, Deakin University , Australia{" "}
                      <div className="flaggg flaggg-au"></div>
                    </li>
                    <li>
                      Saman, Gule, Herriotwatt University , UK{" "}
                      <div className="flaggg flaggg-gb"></div>
                    </li>
                    <li>
                      Shah, Babar, Zayed University , UAE{" "}
                      <div className="flaggg flaggg-ae"></div>
                    </li>

                    <li>
                      Ahmad Mughal,&nbsp;Imran, Institute of Management
                      Sciences, Pakistan{" "}
                      <div className="flaggg flaggg-pk" alt="Pakistan"></div>
                    </li>
                    <li>
                      Ahmad, Ibrar, University of Peshawar , Paksitan{" "}
                      <div className="flaggg flaggg-pk" alt="Pakistan"></div>
                    </li>
                    <li>
                      Ali, Shaukat, University of Peshawar, Pakistan{" "}
                      <div className="flaggg flaggg-pk" alt="Pakistan"></div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TechnicalCommittee;
